/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable jsx-a11y/anchor-is-valid */

import { AVAILABLE_YEARS, HIGHCHART_COLORS, ASEAN_MEMBER } from "../../../../libs/constant";

import React,{FC, useEffect, useState, useMemo} from "react";
import Highcharts from 'highcharts/es-modules/masters/highcharts.src'
import { Dropdown, Card, Row, Spinner, Alert } from "react-bootstrap";
import { getListTradePartnerByCommodity } from '../core/_request';
import * as _ from 'lodash'
import { getNameByISO3, shortenLargeNumber } from "../../../../libs/misc";
import ChartWithShare from "../../../../../ui-kit/ChartWithShare";

type TopPartnerChartCardProps = {
  handlePartnerClicked:(rep:string, partner:string, year:number, flow:string)=>void;
  params:any;
  product_group?: any;
}

interface ExtendedHighchartPiePoint{
  key:string,
  x: number,
  y: number,
  percentage: number
  name:string,
  trade_value: number,
}

interface ExtendedHighchartCreditInterface{
  credits:any
}

interface TopTradeObj {
  name: string, 
  trade_value: number,
  y: number
}


const TopPartnerChartCard:FC<TopPartnerChartCardProps> = ({
  params,
  handlePartnerClicked,
  product_group = [],
}) => {
  const highchartOptions = {
    chart:{
      plotBackgroundColor: null,
      plotBorderWidth: null,
      plotShadow: false,
      type: 'pie',
      marginTop: 0,
      events: {
        load: function (this:ExtendedHighchartCreditInterface) {
          this.credits.element.onclick = function () { window.open('http://comtrade.un.org', '_blank'); }
        }
      }
    },
    tooltip: {
      headerFormat: '',
      pointFormatter: function () {}
    },
    title:{
      text:'',
      visible: false
    },
    series: [{
      data: [1,2,3]
    }],
    plotOptions: {
      pie: {
        size: '60%',
        innerSize: '50%',
        allowPointSelect: true,
        cursor: 'pointer',
        dataLabels: {
          enabled: true,
          formatter: function (this:ExtendedHighchartPiePoint) {
            const {key, percentage} = this
            const dataLabel = (percentage < 0.01) ? '<0.01' : percentage.toFixed(2);
            return `${key}: ${dataLabel}%`;
          },
          style: {
            color: ((Highcharts as any).theme?.contrastTextColor) || 'black',
            fontWeight: 'normal'
          },
          // connectorColor: 'silver'
        }
      }
    },
    credits:{
      enabled: true,
      text: `Data source: UN Comtrade`,
      href: '#',
      position: {
        align: 'center'
      }
    },
    exporting: {
      enabled: true
    },
    accessibility: {
      enabled: false
    }
  };
  const [isLoading, setIsLoading] = useState(false)
  const [isNotFound, setIsNotFound] = useState(false)
  const [selectedYear, setSelectedYear] = useState(AVAILABLE_YEARS[0])
  const [pieChartOptions, setPieChartOptions] = useState<any>(highchartOptions)
  const [worldTradeValue, setWorldTradeValue] = useState(0)
  const [topPartner, setTopPartner] = useState<TopTradeObj[]>([])

  
  // Build dynamic labels and titles using useMemo for stability and performance
  const pgLabel = useMemo(() => {
    const findPG = (id: number, list: any[]): any | null => {
      for (const item of list) {
        if (item.id === id) return item;
        if (item.sub_category?.length) {
          const found = findPG(id, item.sub_category);
          if (found) return found;
        }
      }
      return null;
    };

    const selectedPGs = params.product_group || []
    if (selectedPGs.length === 1) {
      const selectedPG = findPG(+selectedPGs[0], product_group);
      if (selectedPG?.sub_category?.length) {
        return `${selectedPG.name} (Detail)`
      }
      return selectedPG?.name || 'Product Group'
    }
    const selectedNames = selectedPGs.map((pgId: any) => {
      const found = findPG(+pgId, product_group);
      return found?.name || ''
    }).filter(Boolean)
    return selectedNames.length > 0 ? selectedNames.join(', ') : 'Product Group'
  }, [params.product_group, product_group])

  const chartTitle = useMemo(() => {
    return params.tradeflow === 'exports'
      ? `Export destination: ${getNameByISO3(params.rep)} in ${selectedYear}`
      : `Import source: ${getNameByISO3(params.rep)} in ${selectedYear}`;
  }, [params.rep, params.tradeflow, selectedYear])

  const generatePiechart = (params, year) =>{
    setIsNotFound(false)
    const paramsWithYear = {
      ...params,
      product_group: params.product_group,
      tradeflow:params.tradeflow,
      year
    }
    getListTradePartnerByCommodity(paramsWithYear).then(res=>{
      let tradeData = res.data
      if(tradeData.length<1){
        throw Error("Error")
      }     
      //1. Filter out/ Separate that par=WLD
      let worldTradeData = tradeData.filter((trade)=>trade.par==='WLD')

      worldTradeData = [{val: _.chain(worldTradeData).sumBy('val')}]

      //2. Accumulate where reporter is ASEAN
      let tradeDataFiltered = _.chain(tradeData)
        .filter(item => item.par !== 'WLD')
        .groupBy(item => `${item.par}`)
        .map((group, key) => {
          const par = key;
          return {
            rep: 'ASEAN',
            par,
            qty: _.sumBy(group, 'qty'),
            val: _.sumBy(group, 'val')
          };
        })
        .value();
      //3. Accumulate where partner is ASEAN Member for drilldown purposes
      let graph_dataset_drilldown = tradeDataFiltered.filter((item)=>ASEAN_MEMBER.includes(item.par))
      

      const total_drilldown_trade_value = graph_dataset_drilldown.reduce((acc,item)=>acc+=item.val,0)

      graph_dataset_drilldown = graph_dataset_drilldown.map((item,i)=>{
        const percentage = Number(item.val/total_drilldown_trade_value).toFixed(4)
        return {
          name: getNameByISO3(item.par),
          iso3: item.par,
          color:Highcharts.getOptions().colors?.[i] || HIGHCHART_COLORS[i],
          trade_value: item.val,
          y: Number(percentage),
        }
      }).sort((a, b) => b.trade_value - a.trade_value);

      //4. List out Other partner
      const consolidateData = [
        ...tradeDataFiltered.filter(item=>!ASEAN_MEMBER.includes(item.par)),
        {
          rep:'ASEAN',
          par:'ASEAN',
          // flow:1,
          val: total_drilldown_trade_value
        }
      ]
      const tradeDataSorted = _.chain(consolidateData)
                                .orderBy('val','desc')
                                .value()
                                
      //5. Find value selected partner
      // Check if selected partner is in the top 9
      const Top9 = tradeDataSorted.slice(0, 9);
      const isSelectedTop9 = Top9.some(trade => trade.par === params.par || 'WLD');

      let topData;

      if (isSelectedTop9 || params.par==='WLD') {
        topData = Top9;
      } else {
        // Slice top 8
        const top8 = tradeDataSorted.slice(0, 8);

        // Find selected partner from full sorted list
        const selectedData = tradeDataSorted.find(trade => trade.par === params.par || 'WLD');

        // Insert selected partner manually
        topData = [...top8, selectedData];
      }

      // Add percentage calculation
      topData = topData.map(trade => {
        return ({
          ...trade,
          percentage: ((trade.val / worldTradeData[0].val) * 100).toFixed(4)
        })
      });
      const topPartner = new Set(topData.map(trade => trade.par));
      

      const otherParTradeData = tradeDataSorted
        .filter(trade => !topPartner.has(trade.par))
        .reduce((acc, trade) => acc + trade.val, 0);
      
      setWorldTradeValue(worldTradeData[0]?.val)

      graph_dataset_drilldown = {
        name: 'ASEAN',
        id: 'ASEAN',
        data: [...graph_dataset_drilldown],
        point: {
            events: {
              click(e) {
                handlePartnerClicked(params.rep, e.point.iso3, selectedYear, params.tradeflow);
              }
            }
          }
      }

      const graphDataset = [
        ...topData.map((trade, idx)=>{
          if(trade.par==='ASEAN'){
            return {
              name: getNameByISO3(trade.par),
              y: +trade.percentage,
              trade_value: trade.val,
              color: HIGHCHART_COLORS[idx],
              iso3: trade.par,
              tradeflow: trade.flow,
              drilldown:'ASEAN'
            }
          }
          if(trade.par===params.par || 'WLD'){
            return {
              name: getNameByISO3(trade.par),
              y: +trade.percentage,
              trade_value: trade.val,
              color: HIGHCHART_COLORS[idx],
              iso3: trade.par,
              tradeflow: trade.flow,
              dataLabels: { style: { fontWeight: 'bold'} }
            }
          }
          return {
            name: getNameByISO3(trade.par),
            y: +trade.percentage,
            trade_value: trade.val,
            color: HIGHCHART_COLORS[idx],
            iso3: trade.par,
            tradeflow: trade.flow,
          }
        }),
        {
          name: 'Others',
          y: +((otherParTradeData/worldTradeData[0].val)* 100).toFixed(4),
          trade_value:otherParTradeData,
          color: HIGHCHART_COLORS[topData.length+1]
        }
      ]

      setTopPartner(graphDataset)

      setPieChartOptions({
        ...highchartOptions,
        series: [{
          data: graphDataset,
          point: {
            events: {
              click(e) {
                if (e.point.destroyed) {
                    console.log('Drilldown available, no action taken.');
                } else {
                    handlePartnerClicked(params.rep, e.point.iso3, selectedYear, params.tradeflow);
                }
              }
            }
          }
        }],
        drilldown:{
          series: [graph_dataset_drilldown]
        },
        tooltip:{
          headerFormat: '',
          pointFormatter: function (this:ExtendedHighchartPiePoint) {
            const {name, percentage, trade_value, key} = this
            if (name === 'Others') {
              return `
              <strong>${key}</strong>
              <br />Share of Imports: <strong>${percentage.toFixed(2)}%</strong>`;
            } else {
              var formattedPercentage = (percentage < 0.01) ? '<0.01' : percentage.toFixed(2);
              return `
                <strong>${name}</strong>
                <br />Share of Imports: <strong>${formattedPercentage}%</strong>
                <br />Value of Imports: US$ ${shortenLargeNumber(trade_value)}`;
            }
          }
        }
      })
    }).then(()=>{
      setIsLoading(false)
    }).catch(e=>{
      // Toast(
      //   'Something Went Wrong',
      //   'danger',
      //   e.response.data
      // )
      console.error(e)
      setIsNotFound(true)
    })
  }

  useEffect(() => {
    if (!params?.rep) return;
    setIsLoading(true)
    setIsNotFound(false)
    generatePiechart(params, selectedYear)
  }, [params, selectedYear])

  const handleYearChange = (year) =>{
    setSelectedYear(+year)
  }
  let cardBodyContent: React.ReactNode = null;

  if (!isLoading && topPartner.length) {
    cardBodyContent = (
      <Row className="h-100">
        {/* <HighchartsReact
          highcharts={Highcharts}
          options={pieChartOptions}
        /> */}
        <ChartWithShare chartOptions={pieChartOptions} title={`${chartTitle} - ${pgLabel}`}/>
      </Row>
    );
  } 
  // else if (isLoading && isNotFound) {
  //   cardBodyContent = (
  //     <div className="d-flex align-items-center justify-content-center">
  //       <Alert variant="warning">
  //         <Alert.Heading>
  //           <i className="la la-exclamation-triangle" style={{ marginRight: '8px' }}></i>
  //           No Data Found
  //         </Alert.Heading>
  //           We couldn’t find any records for the selected reporter or partner country. 
  //           Please try again with a different selection or check your input for accuracy.
  //       </Alert>
  //     </div>
  //   );
  // } 
  else {
    cardBodyContent = (
      <div className="d-flex align-items-center justify-content-center" style={{ height: '50vh' }}>
        <Spinner animation="border" role="status" variant="primary" className="me-3" />
        <div className="loading-text">
          Loading
          <span className="dot">.</span>
          <span className="dot">.</span>
          <span className="dot">.</span>
        </div>
      </div>
    );
  }

  return (
    <Card className="card-custom">
      <Card.Header className="card-header-stretch">
        <Card.Title
          title={chartTitle}
          style={{
            maxWidth: '80%',
          }}
        >
          <div className="d-flex flex-column">
            <span className="fw-bold">{chartTitle}</span>
            <span className="text-muted fs-7 fw-normal mt-1">{pgLabel}</span>
          </div>
        </Card.Title>
        <Dropdown className="pt-5">
          <Dropdown.Toggle variant="label-brand" id="" className="btn btn-sm btn-bold btn-label-brand dropdown-toggle fw-bold dss_graph_trade_partners_available_years_latest">
            {selectedYear}
          </Dropdown.Toggle>
          <Dropdown.Menu>
            {
              AVAILABLE_YEARS.map(year=>{
                return (<Dropdown.Item key={year} onClick={() => handleYearChange(year)}>{year}</Dropdown.Item>)
              })
            }
          </Dropdown.Menu>
        </Dropdown>
      </Card.Header>
      <Card.Body style={{height:'600px'}}>
        {cardBodyContent}
      </Card.Body>
    </Card>
  )
}

export {TopPartnerChartCard}
